<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {
    this.getScreenSize();
  },
  mounted() {
    window.onresize = () => {
      this.getScreenSize();
    };
  },
  methods: {
    getScreenSize() {
      let width = document.body.clientWidth;
      if (width < 770) {
        this.$store.commit("saveDevice", "mobile");
      } else {
        this.$store.commit("saveDevice", "desktop");
      }
    }
  }
};
</script>

<style lang="scss">
#app {
  font-family: '微软雅黑';
  color: #2c3e50;
  margin: 0;
  padding: 0;

  width: 100%;
  height: 100%;
}
// * {
//   box-sizing: border-box;
// }
body {
  margin: 0;
  padding: 0;
}
.el-input__inner {
  border-radius: 0 !important;
}
.el-input__inner::placeholder {
  color: #969799 !important;
  font-size: 15px;
}
.login_l_t_l .el-input__inner {
  background: transparent !important;
  border: transparent;
}
.login_l_t_r .el-input__inner,
.login_l_pwd .el-input__inner {
  background: transparent !important;
  border-color: transparent;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  height: 48px;
  box-sizing: border-box;
}
.login_l_t_r .el-input__inner:focus,
.login_l_pwd .el-input__inner:focus {
  border-bottom-color: #409eff !important;
}

/* .el-checkbox__inner{
  background:transparent;
  border-color:#409EFF;
}
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    background-color: #409EFF;
    border-color: #409EFF;
} */
.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #606266;
}

.bor_red .el-input__inner {
  border-bottom-color: red !important;
}
.bor_green .el-input__inner {
  border-bottom-color: #11db00 !important;
}


input[type=number] {  
    -moz-appearance:textfield;  
}  
input[type=number]::-webkit-inner-spin-button,  
input[type=number]::-webkit-outer-spin-button {  
    -webkit-appearance: none;  
    margin: 0;  
} 
</style>
